<template>
  <form-group :name="validateName" :attribute="`fields.${validateName}`">
    <template slot-scope="{ attrs }">
      <v-textarea
        v-model="getModelValue"
        v-bind="attrs"
        @keyup="active"
        :rows="rows"
        outlined
        no-resize
      ></v-textarea>
    </template>
  </form-group>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    feildType: {
      default: String
    },
    validateName: {
      required: true,
      type: String
    },
    v: {
      type: Object,
      required: true
    },
    rows: {
      type: String
    }
  },
  computed: {
    getModelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.v.$touch();
        this.$emit("input", value);
      }
    }
  },
  methods: {
    active() {
      this.$emit("activeSaveButton");
    }
  }
};
</script>
